import { render, staticRenderFns } from "./Tenancy.vue?vue&type=template&id=82296d64&scoped=true"
import script from "./Tenancy.vue?vue&type=script&lang=js"
export * from "./Tenancy.vue?vue&type=script&lang=js"
import style0 from "./Tenancy.vue?vue&type=style&index=0&id=82296d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82296d64",
  null
  
)

export default component.exports